import React, { useCallback } from "react";

import { Namespace, useTranslate } from "localization";
import { Button, Modal } from "minimum-ui/core";

import { useChunkError } from "./slice";

const ChunkErrorDialogue: React.FC = () => {
  const { translate } = useTranslate(Namespace.ERROR);
  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  const error = useChunkError();
  if (!error) {
    return null;
  }

  const title =
    error === "chunk_missing"
      ? translate("appUpdatedTitle")
      : translate("pageLoadErrorTitle");
  return (
    <Modal
      isOpen={true}
      disableEscapeAndClickOutside
      title={title}
      content={translate(
        error === "chunk_missing" ? "appUpdatedText" : "pageLoadErrorText"
      )}
      actions={
        <Button onClick={handleReload}>
          {translate("reload", { namespace: Namespace.DEFAULT })}
        </Button>
      }
    />
  );
};

export { ChunkErrorDialogue };
